import React from 'react'
import Breadcrumb from '../breadCrumb/BreadCrumb'
import AboutOne from '../container/pagesContainer/AboutOne'
import Footer from '../footer/Footer'
import SEO from '../seo/SEO'
import TopNav from '../topNav/TopNav'

function About() {
    return (
        <>
            <SEO title="Royality Technologies || About" />
            <TopNav />
            <Breadcrumb title="Home" content="About Us" image="/images/home/slide2.jpg" />
            <AboutOne />
            <Footer/>
        </>
    )
}

export default About